/* eslint-disable import/prefer-default-export */
export const sendToFirebase = (eventName, params, analytics = {}) => {
  try {
    analytics.logEvent(eventName, params);
  } catch (error) {}
};
